import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Output, EventEmitter, OnInit, ChangeDetectorRef } from '@angular/core';
import { DEFAULT_DURATION_LIST } from '@app-core/constants/constants';
import { Days } from '@app-core/models/core.model';
import { DurationRangeService } from '@app-core/services/duration-range/duration-range.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-duration-list',
  templateUrl: './duration-list.component.html',
  styleUrls: ['./duration-list.component.scss'],
})
export class DurationListComponent implements OnInit {
  public durationList = DEFAULT_DURATION_LIST;
  public selectedItem: Days;
  public isMobile = false;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  @Output() durationSelected: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private durationService: DurationRangeService,
    private breakpointObserver: BreakpointObserver,
    private cdRef: ChangeDetectorRef
  ) {
    this.durationList = this.durationService.getDurationList();
  }

  public ngOnInit() {
    // to check if user is logged in from mobile app
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result) => {
        this.isMobile = result.matches;
        this.cdRef.detectChanges(); // Trigger view update
      });
  }

  public onSelectionChange(value) {
    // this.selectedItem = event?.options?.[0]?.value;
    this.selectedItem = value;
    this.durationSelected.emit(this.selectedItem);
  }
}
